import { Grid, Stack, Typography } from "@mui/material";
import { ItemMov, Movimentacao } from "../../mov.model";
import { CardCliente } from "./cardCliente";
import { CardEndereco } from "./endereco";
import { CardObs } from "./obs";
import { CardCanalDist } from "./cardCanalDist";
import { Newspaper } from "@mui/icons-material";
import { TipoMovState } from "../../../tipoMov/tipomov.model";
import { ClienteActions } from "../../../cliente/cliente.model";
import { useState } from "react";
import Alerts from "../../../../components/alerts/Alerts";
import { CardListItemMov, CardSelecionarItem } from "./cardsItem";
import { CardTotalizacao } from "./cardTotal";
import { MeioPagActions } from "../../../meioPag/meiopg.model";
import { FuncionarioActions } from "../../../funcionario/funcionario.model";
import { Item, TabelaPrecoItem } from "../../../../data.types";
import { getNewId, isEmpty } from "../../../../services/utils";
import { FormMovimentacao } from "./formMov";
import { FornecedorActions } from "../../../fornecedor/forn.model";
import { ContentForm } from "../../../../components/viewCadastro/formCad";


interface PedidoTemplateProps {
    clienteActions: ClienteActions;
    fornecedorActions: FornecedorActions;
    funcionarioActions: FuncionarioActions;
    tipoMovState: TipoMovState
    mutatorLocal: (value: any, field: string) => void;
    mov: Movimentacao;
    stateForm:any
    msgError: string,
    meioPagActions: MeioPagActions;
    setShowObsModal: (value: boolean) => void;  
    setShowDescontoModal: (value: boolean) => void;
    getTextMovToShared: () => string;
    showObsModal: boolean;
    showDescontoModal: boolean;
}


const BlockLeft = (props: PedidoTemplateProps) => {
    const { clienteActions, mutatorLocal, mov,setShowObsModal,showObsModal,showDescontoModal,setShowDescontoModal,fornecedorActions,funcionarioActions } = props;
    return (
        <Stack spacing={1} sx={{ display: "flex", flex: 2, flexDirection: "column", mx: 1 }}>
            <Grid container spacing={2}>
                <ContentForm fieldName={"created_at"} type="data" label="Data" colunsXS={12} colunsSM={12} colunsMD={12} />
            </Grid>
            <CardCliente
                clienteActions={clienteActions}
                mutatorLocal={mutatorLocal}
                mov={mov}
            />
            <CardEndereco
                mutatorLocal={mutatorLocal}
                mov={mov}
            />
            <CardCanalDist mov={mov} />
            <CardObs
                mutatorLocal={mutatorLocal}
                mov={mov}
                setShowObsModal={setShowObsModal}
                showObsModal={showObsModal}
            />
            <FormMovimentacao
                clienteActions={clienteActions}
                fornecedorActions={fornecedorActions}
                funcionarioActions={funcionarioActions}
                mutatorLocal={mutatorLocal}
                showDescontoModal={showDescontoModal}
                setShowDescontoModal={setShowDescontoModal}
                mov={mov}
                fieldShow={[]} // Exemplo de campos a serem exibidos
            />

        </Stack>
    )
}

const BlockRight = (props: PedidoTemplateProps) => {
    const { clienteActions, mutatorLocal, mov, tipoMovState,stateForm,msgError,funcionarioActions,getTextMovToShared,meioPagActions,setShowDescontoModal,setShowObsModal,showDescontoModal,showObsModal } = props;
    const [showError, setShowError] = useState(stateForm.invalid && stateForm.submitFailed)
    const [showCopy, setShowCopy] = useState(false);
    const [showMovItem, setShowMovItem] = useState<{ item: ItemMov, show: boolean,operation: "itemMovAdd" | "itemMovUpd" | "" }>({ item: {} as ItemMov, show: false,operation:"" })

      const addItem = (item: Item,tabela:TabelaPrecoItem, fast?: boolean) => {
        //let valor = mov.pessoa.revenda ? item.preco_ata : item.preco_var;
        let valor = tabela.valor;
        let newItemMov: ItemMov = {
          _id: getNewId(),
          item: {
            _id:item._id,
            codigo:item.codigo,
            descricao:item.descricao,
            tabela_preco:tabela,
            info_dt_validade:item.info_dt_validade
          },
          qt: fast ? 1 : 0,
          valor: valor,
          total: valor,
          ano_validade: undefined,
        }
        if (!fast) {
          setShowMovItem({ item: newItemMov, show: true,operation:"itemMovAdd" })
        } else {
          mutatorLocal(newItemMov, "itemMovAdd")
        }
      }

    if (isEmpty(mov.pessoa._id)) {
        return (
            <Stack sx={{ flex: 7 }} justifyContent={"center"} alignItems={"center"}>
                <Stack>
                    <Newspaper sx={{ alignSelf: 'center', fontSize: 60 }} />
                    <Typography variant="h4">{tipoMovState.row.descricao}</Typography>
                </Stack>
            </Stack>
        )
    }

    return (
        <Stack sx={{ display: "flex", flex: 7, flexDirection: "row" }}>
            <Alerts
              show={showError}
              menssage={msgError}
              tipoAlerta="error"
              handleClose={() => setShowError(false)}
            />
            <Alerts
              show={showCopy}
              menssage={"Dados do pedido copiado com sucesso!"}
              tipoAlerta="success"
              handleClose={() => setShowCopy(false)}
            />
            <CardSelecionarItem 
                addItem={addItem} 
                mov={mov}
            />
            <Stack spacing={1} sx={{ display: "flex", flex: 3, flexDirection: "column", }}>
                <CardListItemMov 
                    mov={mov}
                    mutatorLocal={mutatorLocal}
                    showMovItem={showMovItem}
                    setShowMovItem={(value) => setShowMovItem({ ...value, operation: "itemMovUpd" })}    
                    showButtonNew={mov.situacao === "ENTREGA"}  
                    handleButtonNew={() => mutatorLocal("ABERTO", "situacao")}
                />
                <CardTotalizacao 
                    mov={mov}
                    mutatorLocal={mutatorLocal}
                    meioPagActions={meioPagActions}
                    funcionarioActions={funcionarioActions}
                    setShowObsModal={setShowObsModal}
                    setShowCopy={setShowCopy}
                    setShowDescontoModal={setShowDescontoModal}
                    getTextMovToShared={getTextMovToShared}
                />
            </Stack>
        </Stack>
    )
}

export const PedidoTemplate = (props: PedidoTemplateProps) => {

    return (
        <Stack sx={{ display: "flex", flex: 1, flexDirection: "row" }}>
            <BlockLeft {...props} />
            <BlockRight {...props} />
        </Stack>
    )
}